// HighlyTrainedCaregiversSection.js
import React from "react";
import trainedCaregiversImage from "../assets/highly-trained-caregivers-image.jpg";

const HighlyTrainedCaregiversSection = () => {
  return (
    <section className="relative bg-white overflow-hidden">
      {/* Top curved section with gradient */}
      <div
        className="relative"
        style={{
          background: "linear-gradient(90deg, #AD2647 0%, #E85D2C 100%)",
          clipPath: "ellipse(150% 100% at 50% 0%)",
          paddingBottom: "120px",
        }}
      >
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 pt-16 pb-8">
          <div className="max-w-3xl">
            <p className="text-white text-sm font-light tracking-wider mb-3 uppercase">
              ALLAWAH HOME CARE
            </p>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4 leading-tight">
              Proudly Caring for Coolamon's Seniors — One Home at a Time
            </h2>
            <p className="text-white text-sm md:text-base font-light leading-relaxed">
              At Allawah Compassionate Home Care, we believe every senior
              deserves to feel valued, respected, and supported in the place
              they call home. Our caregivers provide personalised care that
              promotes safety, independence, and companionship—helping families
              across Coolamon and beyond find peace of mind and loved ones live
              life to the fullest.
            </p>
          </div>
        </div>
      </div>

      {/* Bottom section with image and content */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Image */}
          <div>
            <img
              src={trainedCaregiversImage}
              alt="Caregiver with elderly woman"
              className="w-full h-auto rounded-2xl shadow-lg object-cover"
            />
          </div>

          {/* Right Content */}
          <div>
            <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6 leading-tight">
              Our Highly Trained Caregivers Understand Dementia
            </h3>

            <div className="space-y-4 text-gray-700 font-light leading-relaxed">
              <p>
                At Allawah Lodge, we specialise in simplifying the process of
                finding the appropriate services and caregiver for your loved
                one.
              </p>

              <p>
                Upon contacting us, we will arrange a free consultation without
                any obligations. This consultation will allow us to
                comprehensively understand your loved one's situation and build
                the groundwork for their care plan. We will also address any
                queries you may have about in-home care.
              </p>

              <p>
                During the consultation, we can discuss your loved one's care
                schedule and create an initial care plan. The care schedule will
                be designed based on your loved one's established routines and
                may include part-time, full-time, or round-the-clock caregiving.
                We can also accommodate care for any family members who reside
                with your loved one or conduct regular care visits.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HighlyTrainedCaregiversSection;
